import { render, staticRenderFns } from "./PinBatchSaleReport.vue?vue&type=template&id=5897b968&scoped=true"
import script from "./PinBatchSaleReport.vue?vue&type=script&lang=js"
export * from "./PinBatchSaleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897b968",
  null
  
)

export default component.exports